'use strict';

const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

exports.floatRegex = floatRegex;
//# sourceMappingURL=float-regex.cjs.map
